angular.module('App.MyAccount.Notifications.Ctrl',[])
.controller('NotificationCtrl', ['$scope', '$log', '$rootScope', 'myAccount', function($scope, $log, $rootScope, myAccount){

    $scope.myAccount.notifications = $scope.myAccount.notifications || {};
    $scope.myAccount.notifications.page = 0;

    $rootScope.breadcrumbsConfig.links.unshift({
        linkText: i18n['NOTIFICATIONS'],
        link: $scope.jvUrls.admin+'/myaccount/profile.html#/notifications'
    });

    var init = function(){
        $scope.flags.loading = true;
        $scope.getNotifcations($scope.myAccount.notifications.page);
    };

    $scope.getNotifcations = function(page){
        $scope.flags.loading = true;
        myAccount.getNotifications(page, function(res){
            if(res && res.emailCategoryPrefs){
                $scope.myAccount.notifications.data = res.emailCategoryPrefs;
                $scope.myAccount.notifications.resultCount = res.resultCount;
                $scope.myAccount.notifications.dataCopy = angular.copy(res.emailCategoryPrefs);
                $scope.myAccount.notifications.count = res.count;
            }
            $scope.flags.loading = false;
        }, function(err){
            $scope.flags.loading = false;
            $log.error(err);
        });
    };

    $scope.uncheckAll = function(){
        for(var i=0; i<$scope.myAccount.notificationsCompany.length; i++){
            if($scope.myAccount.notificationsCompany[i].enabled){
                $scope.myAccount.notificationsCompany[i].enabled = false;
                $scope.myAccount.notificationsCompany[i].changed = true;
            }
        }
    };

    $scope.checkAll = function(company){
        if(company){
            company.unsubscribeAll = false;
            for(var i=0; i<$scope.myAccount.notificationsCompany.length; i++){
                if(!$scope.myAccount.notificationsCompany[i].enabled){
                    $scope.myAccount.notificationsCompany[i].enabled = true;
                    $scope.myAccount.notificationsCompany[i].changed = true;
                }
            }
        }
    };

    $scope.hideModal = function(){
        $scope.myAccount.notifications.showDeleteModal = false;
    };

    $scope.toggleExpansion = function(company){
        var isExpanded = angular.copy(company.expanded);

        for(var i=0; i<$scope.myAccount.notifications.data.length; i++){
            $scope.myAccount.notifications.data[i].expanded = false;
        }

        if(!isExpanded){
            $scope.flags.loading = true;
            var data= {};
            if(company.subsidiaryEId){
                data.subsidiaryEId = company.subsidiaryEId;
            }

            myAccount.getCompanyNotifications(company.companyEId, data, function(res){
                $scope.flags.loading = false;
                $scope.myAccount.notificationsCompany = res.emailCompanyPrefs;
                company.expanded = !company.expanded;
            });
        }
    };

    $scope.toggleCompanySelection = function(company, category){
        category.changed = true;
        if(category.enabled){
            company.unsubscribeAll = false;
        }
    };

    $scope.saveNotifications = function(company){
        $scope.flags.loading = true;

        var postCompany = angular.copy(company);
        var postJobCategories = [];

        if(company.unsubscribeAll){
            myAccount.removeNotifications(postCompany.companyEId, postCompany.subsidiaryEId ? postCompany.subsidiaryEId : null, function(){
                $scope.flags.loading = false;
                $scope.showMsg('COMPANY_UNSUBSCRIBED');
                $scope.myAccount.notifications.showDeleteModal = false;
                init();
            }, function(err){
                $scope.flags.loading = false;
                $log.error(err);
            });
        }else{
            postJobCategories = $.grep($scope.myAccount.notificationsCompany, function(category){
                if(category.changed){
                    return category;
                }
            });

            myAccount.saveNotifications(postCompany.companyEId, postCompany.subsidiaryEId? postCompany.subsidiaryEId : null, postJobCategories, function(){
                $scope.flags.loading = false;
                $scope.showMsg('MYACCOUNT_EMAIL_NOTIFS_UPDATED');
                init();
            }, function(err){
                $scope.flags.loading = false;
                $log.error(err);
            });
        }
    };

    $scope.cancelNotifications = function(company){
        company.expanded = false;
    };

    init();
}]);